<template>
  <div class="pay-success-page">
    <!-- 支付成功区域 -->
    <div class="success-section">
      <img class="success-icon" src="/images/lvyouxian/pay-success-icon.png" alt="支付成功" />
      <h1 class="success-title">支付成功！</h1>
      <!-- <span class="order-code">订单号：{{ $route.query.orderCode }}</span> -->
      <p class="success-subtitle">感谢您的信任，平安行将守护您的旅程。</p>
    </div>

    <!-- 理赔极速指引 -->
    <div class="claim-guide-section">
      <h2 class="guide-title">理赔极速指引</h2>
      <img class="guide-steps" src="/images/lvyouxian/claim-guide-steps.png" alt="理赔步骤" />
    </div>

    <!-- 我的保单悬浮窗（已登录才展示） -->
    <my-policy-float />

    <!-- 未登录提示 -->
    <div v-if="!isLoggedIn" class="login-tip">
      <span class="tip-icon">🔒</span>
      <span class="tip-text">登录后即可查看您的电子保单，</span>
      <span class="tip-link" @click="goLogin">立即登录</span>
    </div>
  </div>
</template>

<script>
import MyPolicyFloat from './MyPolicyFloat.vue';

export default {
  name: 'PaySuccess',
  components: {
    MyPolicyFloat
  },
  data() {
    return {};
  },
  computed: {
    isLoggedIn() {
      return localStorage.getItem('app_login') === '1';
    }
  },
  methods: {
    goLogin() {
      // 登录后回到当前支付成功页
      this.$router.push({
        path: '/login',
        query: { redirect: this.$route.fullPath }
      });
    }
  },
  mounted() {
    // 投保成功页面，不需要录制
  }
};
</script>

<style lang="scss" scoped>
.pay-success-page {
  background-color: #f5f5f5;
  padding: 60px 20px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 支付成功区域 */
.success-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
  .order-code {
    font-size: 16px;
    color: #333;
    margin-bottom: 16px;
  }
  .success-icon {
    width: 138px;
    height: 138px;
    margin-bottom: 38px;
  }

  .success-title {
    font-size: 38px;
    font-weight: 500;
    color: #262626;
    margin-bottom: 16px;
  }

  .success-subtitle {
    font-size: 16px;
    color: #999;
  }
}

/* 理赔极速指引 */
.claim-guide-section {
  width: 100%;
  max-width: 1200px;
  background-color: #fff;
  border-radius: 16px;
  padding: 32px 70px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);

  .guide-title {
    font-size: 28px;
    font-weight: 500;
    color: #262626;
    text-align: center;
    margin-bottom: 45px;
  }

  .guide-steps {
    width: 100%;
    display: block;
  }
}

/* 未登录提示 */
.login-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  padding: 12px 24px;
  background: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 22px;
  font-size: 15px;
  color: #ad6800;

  .tip-icon {
    margin-right: 6px;
    font-size: 16px;
  }

  .tip-link {
    color: #dd122a;
    font-weight: 500;
    cursor: pointer;
    margin-left: 2px;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
